var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-897 -1537)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(897 1537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.414,9.7,7.8,11.3A.7.7,0,1,0,8.8,12.3l2.8-2.8a.723.723,0,0,0,0-.994L8.8,5.7A.7.7,0,0,0,7.8,6.7l1.61,1.6H2.7a.7.7,0,1,0,0,1.4ZM9,2A7,7,0,0,0,2.7,5.885a.7.7,0,0,0,1.26.63,5.628,5.628,0,1,1,.028,4.97.7.7,0,0,0-1.26.63A7,7,0,1,0,9,2Z",
    transform: "translate(898 1538)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDark);
export default __webpack_public_path__ + "static/media/logout-dark.345e01e33283f37cd501541f6ae88494.svg";
export { ForwardRef as ReactComponent };